// Unobtrusive handlers for data-driven UI actions. These replace inline
// `onclick="..."` and `href="javascript:..."` patterns that strict CSP blocks.
//
//   <a data-action="reload">…</a>             → location.reload()
//   <a data-action="print">…</a>              → window.print()
//   <a data-format-export="csv">…</a>         → reloadWithFormat('csv')
//   <a data-format-export="csv" data-export-payload='{"k":"v"}'>…</a>
//                                              → reloadWithFormat('csv', {k:"v"})
document.addEventListener('click', function(event) {
  var formatTarget = event.target.closest('[data-format-export]');
  if (formatTarget) {
    event.preventDefault();
    var format = formatTarget.getAttribute('data-format-export');
    var payloadStr = formatTarget.getAttribute('data-export-payload');
    if (typeof window.reloadWithFormat !== 'function') return;
    if (payloadStr) {
      try {
        window.reloadWithFormat(format, JSON.parse(payloadStr));
      } catch (e) {
        console.error('Invalid data-export-payload JSON:', e);
      }
    } else {
      window.reloadWithFormat(format);
    }
    return;
  }

  var actionTarget = event.target.closest('[data-action]');
  if (!actionTarget) return;

  switch (actionTarget.getAttribute('data-action')) {
    case 'reload':
      event.preventDefault();
      location.reload();
      break;
    case 'print':
      event.preventDefault();
      window.print();
      break;
  }
});
